export enum HTTPMethod {
  Get = 'GET',
  Put = 'PUT',
  Post = 'POST',
  Patch = 'PATCH',
  Delete = 'DELETE',
}

export enum HTTPStatus {
  NotFound = 404,
}
